import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=15817340&scoped=true&lang=pug&"
import script from "./VersionUpdate.vue?vue&type=script&lang=js&"
export * from "./VersionUpdate.vue?vue&type=script&lang=js&"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&id=15817340&lang=scss&scoped=true&"
import style1 from "./VersionUpdate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15817340",
  null
  
)

export default component.exports